import { Delete } from "@mui/icons-material";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";

export default function ContractsDropdownMenu({
  anchorEl,
  open,
  onClose,
  onEdit,
  onDelete,
  contractId = "",
  canEdit = false,
  canDelete = false,
}) {
  return (
    <Menu
      id={`contracts-row-menu-${contractId}`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            boxShadow: "none",
            borderRadius: 2,
            border: `1px solid ${HNSColors.secondary[500]}`,
            "& .MuiMenuItem-root": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 2,
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: HNSColors.tertiary[900],
            },
          },
        },
      }}
    >
      {canEdit && (
        <MenuItem id={`contracts-row-menu-edit-${contractId}`} onClick={onEdit}>
          <ListItemText primary="Edit" />
          <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
            <Svg name={SvgEnum.HisEdit3} color={HNSColors.primary[500]} sx={{ width: "1.25rem" }} />
          </ListItemIcon>
        </MenuItem>
      )}
      {canDelete && (
        <MenuItem id={`contracts-row-menu-delete-${contractId}`} onClick={onDelete}>
          <ListItemText primary="Delete" sx={{ color: HNSColors.failure[500] }} />
          <ListItemIcon sx={{ justifyContent: "flex-end", minWidth: "auto" }}>
            <Delete fontSize="small" sx={{ color: HNSColors.failure[500] }} />
          </ListItemIcon>
        </MenuItem>
      )}
    </Menu>
  );
}
